export enum Role {
  Coworker = 'coworker',
  DigitalizationCoworker = 'digitalization-coworker',
  WorkspaceCoworker = 'workspaceCoworker',
  Inspector = 'inspector',
  DocuManager = 'docuManager',
  DocuResponsible = 'docuResponsible',
  WorkspaceOwner = 'workspaceOwner',
  Reviewer = 'reviewer',
  Admin = 'admin',
}
